import { useEffect, useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';

const NS = 'http://www.w3.org/2000/svg';

const createColorFilter = (filterMatrix, filterId) => {
  const filter = document.createElementNS(NS, 'filter');
  const feColorMatrix = document.createElementNS(NS, 'feColorMatrix');

  filter.id = filterId;
  filter.filerRes = '1';
  filter.setAttribute('color-interpolation-filters', 'sRGB');
  feColorMatrix.setAttribute('in', 'SourceGraphic');
  feColorMatrix.setAttribute('type', 'matrix');
  feColorMatrix.setAttribute('values', filterMatrix);

  filter.appendChild(feColorMatrix);

  return filter;
};

const useColorFilter = (filter) => {
  const ref = useRef();
  const id = uuidv4();
  useEffect(() => {
    if (ref.current) {
      const colorFilter = createColorFilter(filter, id);
      const previousFilter = ref.current.getElementById(id);
      if (previousFilter) {
        previousFilter.replaceWith(colorFilter);
      } else {
        ref.current.appendChild(colorFilter);
      }
      ref.current.setAttribute('filter', `url(#${id})`);
    }
  }, [filter, ref.current]);
  return ref;
};

export default useColorFilter;
